const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function validWorkspaceTimeZone(value) {
  if (typeof value !== 'string' || value.length > 100 || value.trim() !== value || (value !== 'UTC' && !value.includes('/'))) return false;
  try { new Intl.DateTimeFormat('en', { timeZone: value }).format(); return true; } catch { return false; }
}
export function workspaceTimeZones(current = 'America/Toronto') {
  const supported = typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : [];
  return [...new Set(['America/Toronto', 'UTC', ...supported, ...(validWorkspaceTimeZone(current) ? [current] : [])])].sort();
}
export function checkedWorkspaceDefaults(value, companyId) {
  if (!UUID.test(companyId || '') || value?.companyId !== companyId || !Number.isSafeInteger(value.revision) || value.revision < 0) throw new Error('invalid_workspace_defaults');
  if (value.revision === 0) {
    if (value.countryCode !== null || value.timeZone !== null) throw new Error('invalid_workspace_defaults');
  } else if (!['CA', 'US'].includes(value.countryCode) || !validWorkspaceTimeZone(value.timeZone)) throw new Error('invalid_workspace_defaults');
  return value;
}
export function workspaceDefaultsBody({ countryCode, timeZone, revision } = {}) {
  if (!['CA', 'US'].includes(countryCode) || !validWorkspaceTimeZone(timeZone) || !Number.isSafeInteger(revision) || revision < 0) throw new Error('invalid_workspace_defaults');
  return { countryCode, timeZone, expectedRevision: revision };
}
